module.exports = "/images/play.svg?754a2dbfa2dcc03bbcfa0816cad2a677";